module.exports = __webpack_public_path__ + "img/invite-success-68c59ebe4d1d423d4e22735177db0472.png";